import { Statement } from './statement.page';

export { Statement };
